export default "__VITE_ASSET__CU8ABNtn__"